module.exports = __webpack_public_path__ + "static/img/humax-mobility.fb6275b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/humax-mobility.jpg
// module id = ecCK
// module chunks = 0